import React from 'react';
import { AutoHideScrollArea } from '@/components/AutoHideScrollArea';
import { JournalCard } from '@/pages/Overview/JournalCard';
import { getJournalKey, getTeacherNames } from '@/utils/journal';
import type { Journal } from '@/types/journal';

interface Props {
  journals: Journal[];
  selectedJournal?: Journal;
  onSelect: (journal: Journal) => void;
}

export const JournalList: React.FC<Props> = ({
  journals,
  selectedJournal,
  onSelect,
}) => (
  <AutoHideScrollArea
    hasTopShadow
    className="flex w-full flex-col md:w-[257px]"
  >
    <div className="flex flex-col gap-1 p-2">
      {journals.map((journal) => (
        <JournalCard
          key={getJournalKey(journal.journalId)}
          name={journal.name}
          teachers={getTeacherNames(journal)}
          isSelected={journal === selectedJournal}
          onSelect={() => onSelect(journal)}
        />
      ))}
    </div>
  </AutoHideScrollArea>
);
